"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
const getSessionToken_1 = __importDefault(require("../../../utils/login/getSessionToken"));
/**
 * Client interface to make Register Driver for booking API call
 * @param {DriverRegisterParamType} reqParam
 * @param {string} quoteId
 * @param rtoken {string} Google recaptcha token
 * @returns {Promise} The API does not return response body
 */
const registerDriver = (reqParam, quoteId, rtoken) => {
    const requestId = 'REGISTER_DRIVER_BOOKING';
    console.log('** recaptcha token register driver: ', rtoken);
    // discussed with backend
    // session token can be passed in header for logged in user
    // if user not logged in, then do not pass Bearer token
    const sessionToken = (0, getSessionToken_1.default)();
    const config = {
        headers: {
            'x-recaptcha-token': rtoken,
        },
        data: reqParam,
    };
    if (sessionToken) {
        config.headers = Object.assign(Object.assign({}, config.headers), { Authorization: `Bearer ${sessionToken}` });
    }
    const rawEndpoint = ENDPOINTS_1.default.BOOKING_SERVICE.REGISTER_DRIVER;
    const endPoint = rawEndpoint.replace('{quoteId}', quoteId);
    return http_service_1.default
        .post(requestId, endPoint, config)
        .then((response) => response.data);
};
exports.default = registerDriver;
